import * as d3 from 'd3';
import { useEffect, useState, useContext } from "react";
import { API } from "../../../API";
import { ShareAPI } from "../../../API";
import { narrativeActorsUrl } from "../../../utils/narrativeActors";
import { useTranslation } from 'react-i18next';
import { BreakdownsContext } from "./contexts/BreakdownsContext";
import { BreakdownsContainer } from "../../../components/BreakdownsContainer/BreakdownsContainer";
import { LoaderSmall } from "../../../components/LoaderSmall/LoaderSmall";
import { cutString } from "../../../utils/cutString";
import Tooltip from "../../../components/Tooltip/Tooltip";
import styles from '../NarrativePage.module.scss';
import { formatNumberSignificant } from '../../../utils/fomatNumbers';
import { showRequestError } from '../../../utils/requestError';

export const TopTagsByPosts = ({narrative, isShare, isClickable=true, title, size=15}) => {
  const { t } = useTranslation();
  const [tags, setTags] = useState(null);

  const {openModal, setTagsFilter, setCurrentWidgetName} = useContext(BreakdownsContext);

  const api = isShare ? ShareAPI : API;

  const getTags = () => {
    const urlParams = new URLSearchParams();
    urlParams.set('size', size);
    urlParams.set('widget_name', `top_tags_breakdown`);
    api.fetch('GET', narrativeActorsUrl(narrative.id, 'tags', urlParams)).then(
      data => setTags(data)
    ).catch(e => { showRequestError(e, t('Top actor groups')); setTags([]); })
  }

  useEffect(() => {
    getTags()
  }, [narrative.id])

  return(
    <BreakdownsContainer
      title={title ? title : t('Top tags by number of posts')}
      onClick={() => openModal()}
      details={false}
    >
     {tags
      ? (tags.objects?.length > 0
      ? <div className={styles.topTagsContainer}>
          <div className={styles.nameHeader}><h5>{t('Tag')}</h5></div>
          <div className={styles.sourcesHeader}><h5>{t('Actors')}</h5></div>
          <div className={styles.messagesHeader}><h5>{t('Publications')}</h5></div>
          <div className={styles.name}>
            <div className={styles.breakdownsListMain}>
              {tags?.objects?.map(tag => {
                return(
                  <div key={`tags_name_${tag?.id}`} className={styles.listItem}>
                    <div className={styles.info}>
                      <span
                        className={styles.title}
                        onClick={() => {
                          if(isClickable) {
                            setTagsFilter([tag.id])
                            setCurrentWidgetName('top_tags_breakdown')
                            openModal()
                          }
                        }}
                        >
                          <Tooltip content={tag.name} position='right'>
                            {cutString(tag.name, 40)}
                          </Tooltip>
                        </span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className={styles.sources}>
            <div className={styles.breakdownsListMain}>
              {tags?.objects?.map(tag => {
                return(
                  <div key={`tags_sources_${tag?.id}`} className={styles.listItem}>
                    <div className={styles.count}>{formatNumberSignificant(tag.number_of_sources)}</div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className={styles.messages}>
            <div className={styles.breakdownsListMain}>
              {tags?.objects?.map(tag => {
                return(
                  <div key={`tags_messages_${tag?.id}`} className={styles.listItem}>
                    <div className={styles.count}>{tag.messages_count}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      : <div className={styles.noData}>{t('There is no data to display')}</div>
      ) : (<div className={styles.widdgetLoader}><LoaderSmall /></div>)}

    </BreakdownsContainer>
  )
}
